import {Navigate, useLocation} from 'react-router-dom';
import {getAuthSession} from './utils/authSession';

const ProtectedRoute = ({element, allowedRoutes = [], ...rest}) => {
	const {isLoggedIn} = getAuthSession();
	const location = useLocation();

	if (!isLoggedIn) {
		return <Navigate to="/login" replace/>;
	}

	const hasVisitedMd = localStorage.getItem('visitedMd') === 'true';
	const hasVisitedSc = localStorage.getItem('visitedSc') === 'true';
	const hasVisitedMp = localStorage.getItem('visitedMp') === 'true';
	const hasVisitedSsc = localStorage.getItem('visitedSsc') === 'true';


	if (location.pathname === '/sc' && !hasVisitedMd) {
		return <Navigate to="/md" replace/>;
	}

	if (location.pathname === '/ssc' && !hasVisitedSc) {
		return <Navigate to="/sc" replace/>;
	}

	const hittingEditOrAdd = location.pathname.startsWith('/ep/') || location.pathname.startsWith('/ap/');

	if (hittingEditOrAdd && !hasVisitedMp && !hasVisitedSsc) {
		return <Navigate to="/mp" replace/>;
	}

	return element;
};

export default ProtectedRoute;